import { makeService } from './api';

const service = makeService('subscribers');

export default service;
